import { Card, Divider, Tag } from '@blueprintjs/core';
import { legacy_import } from '@axo/shared/data-access/types';
import { CreatedAtTag } from '../CommunicationItem';
import cardClasses from '../CommunicationItem/Card.module.css';
import styles from './BankNotesCardView.module.css';
import { Bank } from '@axo/ui-content/features/Partners';
import type { BankCode } from '@axo/ui-content/features/Partners/Bank';

interface IBankNoteCardView {
  bankNote: legacy_import.Note;
  lenderName?: string;
  lenderShortName?: string;
}

export function BankNotesCardView({
  bankNote,
  lenderName,
  lenderShortName,
}: IBankNoteCardView) {
  return (
    <Card className={cardClasses.card}>
      <div className={cardClasses.topBar}>
        {lenderShortName ? (
          <Bank
            className={styles.logo}
            code={lenderShortName as BankCode}
            name={lenderName}
            country={bankNote.MarketCountry}
          />
        ) : (
          <Tag minimal intent={'none'}>
            {'Created by: ' + bankNote.CreatedBy}
          </Tag>
        )}
        <CreatedAtTag label="Made on:" createdAt={bankNote.CreatedAt} />
      </div>
      <Divider />
      <div className={cardClasses.body}>{bankNote.Content}</div>
    </Card>
  );
}
